/**
* @ngdoc service
* @name common.service:ItxLoginSvc
* @requires $q
* @requires $rootScope
* @requires ItxHeaderFct
* @requires ngDialog
* @requires ItxScreenSizeSvc
* @requires imAccessService
* @description
* Login service
* Manage login logic
*/
(function () {
    'use strict';

    angular.module('itxApp.legacy')
           .service('ItxLoginSvc', ItxLoginSvc);

    ItxLoginSvc.$inject = [];

    function ItxLoginSvc() {

        var service = {
            isLogged: isLogged, // se usa
        };

        return service;

        /**
         * @ngdoc method
         * @name isLogged
         * @methodOf  common.service:ItxLoginSvc
         * @description
         *
         * Check if user is logged with following logic.
         * If `inditex.iUserJSON.userType === 'G' ` is a Guest and not logged.
         * If `inditex.iUserJSON.userType === 'R'` the user is logged in.
         * Otherwise is not logged.
         *
         * @returns {boolean} isLogged - Wishlist products
         */
        function isLogged() {

            if ('iUserJSON' in inditex && 'userType' in inditex.iUserJSON) {
                if (inditex.iUserJSON.userType === 'G') {
                    return false;
                }
                if (inditex.iUserJSON.userType === 'R') {
                    return true;
                }
            }
            return false;
        }

    }

})();
